import React, { Component } from 'react'
import { connect }  from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import hoist from 'hoist-non-react-statics'
import Meta from 'components/layout/Meta'
import { actions } from './redux'
import './Product.scss'
class Product extends Component {
  static title = '账户充值';

  constructor(props) {
    super(props)
  }

  componentDidMount(){
    //产品介绍更多和收起事件
    $(".rightCon").on('click','.customer-describe-part .main-hue',function(){
      $(this).parent(".customer-describe-part").hide().next(".customer-describe-all").show();
    });
    $(".rightCon").on('click','.customer-describe-all .main-hue',function(){
      $(this).parent(".customer-describe-all").hide().prev(".customer-describe-part").show();
    });
  }

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    )
  }
}
export default Product



// WEBPACK FOOTER //
// ./modules/productIntroduction/Product.js